import { TemplateFormat } from '@langchain/core/prompts';

import { getNodesFromTemplate } from './RichTextEditor.utils';

// Function to check if either the start or end position is within a template variable
export const isSelectionInsideVariable = (
  startPos: number,
  endPos: number,
  template: string,
  templateFormat: TemplateFormat
): boolean => {
  if (startPos >= endPos) {
    return false;
  }

  // The positions are 1-indexed in the SelectionTooltipExtension
  let currentPos = 1;
  const nodes = getNodesFromTemplate(template, templateFormat, true);

  for (const node of nodes) {
    const nodeEnd = currentPos + node.textWithDelimiters.length;

    if (node.type === 'variable') {
      // Check if either start or end position is within this variable
      const isStartInVariable = startPos > currentPos && startPos < nodeEnd;
      const isEndInVariable = endPos > currentPos && endPos < nodeEnd;

      if (isStartInVariable || isEndInVariable) {
        return true;
      }
    }

    currentPos = nodeEnd;
  }

  return false;
};
